import { structureOperation } from './request';
export default {
  data() {
    return {
      dialogVisible: false,
      structureId: undefined,
      dataFrom: {
        customerId: this.$route.params.customerId,
        structureId: undefined,
        name: ''
      },
      treeData: []
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('部门名称'),
          trigger: 'blur'
        }],
        parentId: [{
          required: true,
          message: this.$t('请选择') + this.$t('部门'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    init(arr) {
      this.treeData = arr;
      this.dialogVisible = true;
    },
    filterTreeOption(input, treeNode) {
      return treeNode.data.props.title.includes(input);
    },
    onChange(value) {
      this.dataFrom.structureId = value;
    },
    handleSure() {
      this.$refs.dataeRef.validate(async valid => {
        if (valid) {
          const res = await structureOperation(this.dataFrom);
          this.$message.success(this.$t('操作成功') + '!');
          this.$emit('ok', String(res));
          this.$emit('cancel');
        }
      });
    }
  }
};